import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import api, { ASSET_URL } from "@/lib/api";

export default function OrderConfirmation() {
  const { orderNumber } = useParams();
  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get(`/orders/${orderNumber}`)
      .then((res) => setOrder(res.data))
      .catch(() => setError("Order not found."));
  }, [orderNumber]);

  if (error) return <p className="text-red-600">{error}</p>;
  if (!order) return <p>Loading…</p>;

  return (
    <div className="mx-auto max-w-xl text-center">
      <CheckCircle2 className="mx-auto text-fairway-600" size={48} />
      <h1 className="mt-3 text-2xl font-extrabold">Thank you!</h1>
      <p className="text-gray-600">
        Order <span className="font-bold">{order.order_number}</span> has been
        received.
      </p>

      <div className="card mt-6 space-y-2 p-6 text-left text-sm">
        {order.event_name && (
          <p>
            <span className="text-gray-500">Event:</span> {order.event_name}
          </p>
        )}
        <p>
          <span className="text-gray-500">Company:</span> {order.company_name}
        </p>
        <p>
          <span className="text-gray-500">Total:</span> ${order.total?.toFixed(2)}
        </p>
        <p>
          <span className="text-gray-500">Status:</span> {order.status}
        </p>
        {order.logo_filename && (
          <div>
            <span className="text-gray-500">Logo:</span>
            <img
              src={`${ASSET_URL}/uploads/${order.logo_filename}`}
              alt="Order logo"
              className="mt-1 h-20 rounded border border-gray-200 object-contain p-1"
            />
          </div>
        )}
      </div>

      <Link to="/" className="btn-primary mt-6">
        Back to Home
      </Link>
    </div>
  );
}
